import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import store from './store';
import './styles/custom.css';
import './styles/dynamic-table.css';
import VueApexCharts from 'vue3-apexcharts';

const app = createApp(App);
app.component('ApexChart', VueApexCharts);
app.use(store);
app.mount('#app');